import { render, staticRenderFns } from "./DisclaimerBar.vue?vue&type=template&id=f0f0f60e&scoped=true&"
import script from "./DisclaimerBar.vue?vue&type=script&lang=js&"
export * from "./DisclaimerBar.vue?vue&type=script&lang=js&"
import style0 from "./DisclaimerBar.vue?vue&type=style&index=0&id=f0f0f60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f0f60e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0f0f60e')) {
      api.createRecord('f0f0f60e', component.options)
    } else {
      api.reload('f0f0f60e', component.options)
    }
    module.hot.accept("./DisclaimerBar.vue?vue&type=template&id=f0f0f60e&scoped=true&", function () {
      api.rerender('f0f0f60e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Bars/DisclaimerBar.vue"
export default component.exports